import Reflux from 'reflux';

module.exports = Reflux.createActions(
  [
    'getAllData',
    // 'onMainDataCustom'
    // 'refreshAllData'
  ]
);



// WEBPACK FOOTER //
// src/actions.jsx